module.exports = __webpack_public_path__ + "static/media/avanzaWhite@3x.da53697b.png";